import { Component, Inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'lla-month-selector-dialog',
  templateUrl: './month-selector-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MonthSelectorDialogComponent {
  selectedMonth: number
  includeFuture: boolean

  constructor(
    public dialogRef: MatDialogRef<MonthSelectorDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      selectedMonth: number
      includeFuture: boolean
    }
  ) {
    this.selectedMonth = data.selectedMonth
    this.includeFuture = data.includeFuture
  }

  onMonthSelected(value: number) {
    this.dialogRef.close(value)
  }
}
